module.exports = __webpack_public_path__ + "static/media/37import-71.fd342f8e.xlsx";